/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { Badge, Button, Nav } from 'react-bootstrap';
import './index.css';
import { useCookies } from 'react-cookie';
import { clear, getItem } from '../../utils/storage';
import { client } from '../../utils/matrix';
import logoMinervaBianco from '../../images/logo-minerva-bianco.svg';
import logoEuBianco from '../../images/logo-eu-su-blu.svg';
import logoDfpBianco from '../../images/funzione-pubblica-su-blu.svg';
import themeColors from '../../utils/contants/theme-colors';

export default function Header({
  handleOpen,
  showSidebarButton,
  areaOspite,
}) {
  const [notifica, setNotifica] = useState(0);
  const [cookies, setCookie, removeCookie] = useCookies(['cookie-name']);
  // useEffect
  useEffect(() => {
    // Imposta il numero iniziale di notifiche
    setTimeout(
      () => {
        if (client) {
          const notificheRoom = client.getRooms().find((el) => el.name === 'Notifiche');
          if (notificheRoom) {
            setNotifica(notificheRoom.notificationCounts.total);
          }
        }

        // Funzione per aggiornare le notifiche ogni volta che c'è un evento
        const updateNotifications = () => {
          const notificheRoom = client.getRooms().find((el) => el.name === 'Notifiche');
          if (notificheRoom) {
            setNotifica(notificheRoom.notificationCounts.total);
          }
        };

        // Ascolta gli eventi e aggiorna le notifiche
        client?.on('event', updateNotifications);

        // Cleanup per evitare memory leaks
        return () => {
          client?.off('event', updateNotifications);
        };
      },
      5000,
    );
  }, []);

  return (
    <header className="it-header-wrapper header-shadow">
      <div className="it-header-slim-wrapper" style={{ backgroundColor: themeColors.secondary, borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="it-header-slim-wrapper-content">
                <a
                  className="d-lg-block navbar-brand text-white"
                  href="http://www.funzionepubblica.gov.it/"
                  target="_blank"
                  rel="noreferrer"
                  title="Collegamento a sito esterno - Dipartimento della funzione pubblica - si apre una nuova finestra"
                  aria-label="Dipartimento della Funzione Pubblica"
                >
                  Dipartimento della funzione pubblica
                </a>
                <div className="header-slim-right-zone">
                  {(client && getItem('identita')) && (
                    <Link
                      to="/area-riservata/notifiche"
                      className="btn rounded-2 text-white text-decoration-none border-0 me-1"
                      style={{ padding: '12px 8px' }}
                    >
                      <FontAwesomeIcon
                        aria-hidden="true"
                        icon="bell"
                        size="lg"
                      />
                      &nbsp;
                      <Badge bg="secondary">
                        {notifica}
                      </Badge>
                      <span className="sr-only">notifiche non lette</span>
                    </Link>
                  )}
                  <a
                    href="/"
                    className="btn btn-outline-secondary btn-full rounded-2 text-white d-flex align-items-center"
                    onClick={() => {
                      client?.logout();
                      clear();
                      removeCookie('loggedIn', { path: '/' });
                    }}
                  >
                    <FontAwesomeIcon
                      aria-hidden="true"
                      icon="sign-out-alt"
                      size="lg"
                    />
                    <span style={{ paddingLeft: '2px' }}>Logout</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="it-header-center-wrapper theme-dark" style={{ backgroundColor: themeColors.secondary, paddingLeft: '18px' }}>
        <div className="container">
          <div className="row h-100">
            <div className="col-12 h-100">
              <div className="it-header-center-content-wrapper d-flex align-items-center justify-content-start gap-4 h-100 px-0">
                <div className="it-brand-wrapper ps-0 gap-2 d-flex align-items-center justify-content-start h-100">
                  {showSidebarButton && (
                  <div className="d-flex justify-content-center align-items-center">
                    <Button variant="outline-light" id="sidebarToggle" onClick={() => handleOpen()} style={{ border: 'none', backgroundColor: 'transparent' }}>
                      <FontAwesomeIcon aria-hidden="true" icon="bars" size="lg" color="white" />
                      <span className="sr-only">Apertura sidebar</span>
                    </Button>
                  </div>
                  )}
                  <Link to="/" title="Vai alla pagina: Homepage" className="d-flex align-items-center h-100">
                    <svg className="icon" aria-hidden="true">
                      <image xlinkHref={logoMinervaBianco} alt="Logo Minerva" />
                    </svg>
                  </Link>
                </div>
                <div className="d-flex align-items-center h-100 gap-3">
                  <div className="d-none d-lg-block" style={{ width: '2px', height: '60px', backgroundColor: 'rgba(255,255,255,0.3)' }} />
                  <div className="d-none d-lg-flex align-items-center gap-3 pe-4">
                    <img height="55px" src={logoEuBianco} alt="Logo Next Generation EU" />
                    <img height="55px" src={logoDfpBianco} alt="Logo Dipartimento della Funzione Pubblica" />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      {!areaOspite && (
        <Navbar collapseOnSelect expand="sm" variant="dark" role="banner" aria-label="Menu di navigazione" style={{ backgroundColor: themeColors.secondary, paddingLeft: '18px' }}>
          <Container>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{ marginLeft: '30px' }}>
              <FontAwesomeIcon aria-hidden="true" icon="ellipsis-v" size="lg" color="white" />
              <span className="sr-only">Apertura opzioni header</span>
            </Navbar.Toggle>
            <Navbar.Collapse id="responsive-navbar-nav" style={{ flexGrow: 0 }}>
              <Nav className="me-auto">
                <Link to="/area-riservata/scelta-identita?from=area-riservata" className="m-2 text-white fw-bold text-decoration-none">
                  <FontAwesomeIcon aria-hidden="true" icon={['far', 'address-card']} size="lg" />
                  {' '}
                  {getItem('identita') ? (JSON.parse(getItem('identita')))?.nomeIdentita : 'Scelta identità'}
                </Link>
                <Link to="/area-riservata/account" className="m-2 text-white fw-bold text-decoration-none">
                  <FontAwesomeIcon aria-hidden="true" icon="user-circle" size="lg" />
                  {' '}
                  Account
                </Link>
                <Link to="/area-riservata/help-desk" className="m-2 text-white fw-bold text-decoration-none">
                  <FontAwesomeIcon aria-hidden="true" icon="handshake-angle" size="lg" />
                  {' '}
                  Help Desk
                </Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      )}
    </header>
  );
}
